import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { EventReducer } from 'Types/EventTypes';

// Calls startNewSession once each time a new app sitting starts because the app
// came back after a long absence (see Models/sittingRotation) while the calling
// screen is on screen. Not for the sitting the screen mounted in, and not for a
// sign-in or sign-out. A screen's open play session belongs to the sitting it was
// opened in, so on such a return the screen opens a new one under the new sitting
// rather than writing more into the old one, which the server may have ended.
export const useNewSessionOnResumedSitting = (startNewSession: () => void): void => {
  const { sessionId, sittingStartReason } = useSelector(
    (state: EventReducer) => state.eventReducer,
  );
  const seenSessionId = useRef(sessionId);
  const startNewSessionRef = useRef(startNewSession);
  startNewSessionRef.current = startNewSession;

  useEffect(() => {
    if (seenSessionId.current === sessionId) return;
    seenSessionId.current = sessionId;
    if (sittingStartReason === 'resumed') startNewSessionRef.current();
  }, [sessionId, sittingStartReason]);
};
